module.exports = __webpack_public_path__ + "img/tankmaze.c0c9e5ef.jpg";